import { render, staticRenderFns } from "./StatisticsHeatMapRow.vue?vue&type=template&id=23229ba0&scoped=true"
import script from "./StatisticsHeatMapRow.vue?vue&type=script&lang=js"
export * from "./StatisticsHeatMapRow.vue?vue&type=script&lang=js"
import style0 from "./StatisticsHeatMapRow.vue?vue&type=style&index=0&id=23229ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23229ba0",
  null
  
)

export default component.exports